<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Project</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.name" label="Project Name"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                  v-model="editedItem.project_type_id"
                  :items="indexData.projectTypes"
                  item-text="name" 
                  item-value="id"
                  box label="Project Type"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.begin_date" label="Starting Time"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.end_date" label="Ending Time"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.details" label="Details"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.created_by }}</td>
        <td class="text-xs-center">{{ props.item.client_id }}</td>
        <td class="text-xs-center">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.completion_percentage }}</td>
        <td class="text-xs-center">{{ props.item.begin_date }}</td>
        <td class="text-xs-center">{{ props.item.end_date }}</td>
        <td class="text-xs-center">{{ props.item.project_types.name }}</td>
        <td class="text-xs-center">{{ props.item.details }}</td>
        <td class="text-xs-center">{{ props.item.total_budget_amount }}</td>
        <td class="text-xs-center">{{ props.item.total_budget_coins }}</td>
        <td class="text-xs-center">{{ props.item.budget_to_dasher }}</td>
        <td class="text-xs-center">{{ props.item.budget_to_administration }}</td>
        <td class="text-xs-center">{{ props.item.budget_remains }}</td>
        <!-- <td class="text-xs-center">{{ props.item.name }}</td> -->
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'project',
      headers: [
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Client ID',
          align: 'center',
          sortable: false,
          value: 'client_id'
        },
        {
          text: 'Name',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Completion(%)',
          align: 'center',
          sortable: false,
          value: 'completion_percentage'
        },
        {
          text: 'Starting Time',
          align: 'center',
          sortable: false,
          value: 'begin_date'
        },
        {
          text: 'Ending Time',
          align: 'center',
          sortable: false,
          value: 'end_date'
        },
        {
          text: 'Project Type',
          align: 'center',
          sortable: false,
          value: 'project_type_id'
        },
        {
          text: 'Details',
          align: 'center',
          sortable: false,
          value: 'details'
        },
        {
          text: 'Total Budget(amount)',
          align: 'center',
          sortable: false,
          value: 'total_budget_amount'
        },
        {
          text: 'Total Budget(coins)',
          align: 'center',
          sortable: false,
          value: 'total_budget_coins'
        },
        {
          text: 'Budget(dasher)',
          align: 'center',
          sortable: false,
          value: 'budget_to_dasher'
        },
        {
          text: 'Budget(clementine)',
          align: 'center',
          sortable: false,
          value: 'budget_to_administration'
        },
        {
          text: 'Remaining Budget',
          align: 'center',
          sortable: false,
          value: 'budget_remains'
        },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        // {
        //   text: 'Gender Name',
        //   align: 'center',
        //   sortable: false,
        //   value: 'name'
        // },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: { 
        name: '',
        begin_date: '',
        end_date: '',
        project_type_id: '',
        details: '',
      },
      defaultItem: {
        name: '',
        begin_date: '',
        end_date: '',
        project_type_id: '',
        details: '',
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'Create' : 'Edit'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.datas.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.datas.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>